import https from "../../configs/axios.config";
import { API_ROUTES } from "../../constants/API_ROUTES";

export const ticketService = {
  get_all: async (customer_id, page, limit, token) => {
    const response = await https.get(
      `${API_ROUTES.TICKET.GET_ALL}/${customer_id}?page=${page}&limit=${limit}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  },
  get_by_id: async (ticket_id, token) => {
    const response = await https.get(
      `${API_ROUTES.TICKET.GET_BY_ID}/${ticket_id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  },
  delete: (ticket_id, token) => {
    const uri = `${API_ROUTES.TICKET.DELETE}/${ticket_id}`;
    return https.delete(uri, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  edit_ticket: (ticket_id, status, token) => {
    const uri = `${API_ROUTES.TICKET.UPDATE}/${ticket_id}`;
    return https.put(
      uri,
      { status: status },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
  },
  response: (ticket_id, response, token) => {
    const uri = `${API_ROUTES.TICKET.RESPONSE}/${ticket_id}`;
    return https.put(
      uri,
      { adminResponse: response },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
  },
};
